import Store from './Store';
import has from 'lodash/has';

export default class SessionStorePlugin {
	static install(Vue, options) {
		Vue.sessionStore = Vue.prototype.$sessionStore = Store;
		Vue.mixin({
			props: {
				uid: {
					type: [null, String],
					default: null
				}
			},
			created() {
				if (this.$options.session && Array.isArray(this.$options.session)) {
					const getVariablePath = (item) => {
						let vm = this;
						let path = [];
						for (let i = 0; i < 15; i++) {
							(vm.$options.name || vm.$options._componentTag)
                            && path.push(vm.$options.name || vm.$options._componentTag);
							(vm.$props['uid'] || vm.$options['uid'])
                            && path.push('(' + (vm.$props['uid'] || vm.$options['uid']) + ')');
							if (has(vm, '$parent') && vm.$parent) vm = vm.$parent;
							else break;
						}
						return item + ':' + path.join('.');
					};
					for (let item of this.$options.session) {
						let propName = getVariablePath(item);
						if (has(this.$data, item)) {
							has(Store.$data, propName) &&
                            (this.$data[item] = Store.$data[propName]);
							this.$watch(item, {
								handler: (value, oldValue) => {
									Store.$data[propName] = value;
								},
								deep: true
							});
						}
					}
				}
			},
			watch: {}
		});
	}
}